import { SyncStatusKey } from "./SyncStatusKey";

export default SyncStatusKey;
